/* cm-pdp.js: behaviour for the Carry-More product page sections.
   Gallery, AJAX add to bag (opens the theme cart drawer), one-tap add-ons,
   sticky bar, feature tour tabs and hotspots. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- cart helpers ----------
     Mirrors the theme's own product form (FoxTheme): bundle the sections the
     cart drawer and header ask for, add, publish cartUpdate so they re-render,
     fire product-ajax:added for FoxKit, then open the drawer. Falls back to a
     plain AJAX add plus count update when FoxTheme is not on the page. */
  var FT = function () { return window.FoxTheme && FoxTheme.pubsub && FoxTheme.routes ? FoxTheme : null; };
  function addToCart(id, qty, opts) {
    opts = opts || {};
    var ft = FT();
    var sections = [];
    if (ft) document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
    var body = { items: [{ id: Number(id), quantity: Number(qty || 1) }] };
    if (sections.length) { body.sections = sections; body.section_url = window.location.pathname; }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) { return res.json().then(function (j) { if (!res.ok || j.status) throw new Error(j.description || res.status); return j; }); })
      .then(function (parsed) {
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          if (ft) {
            cart.sections = parsed.sections;
            ft.pubsub.publish(ft.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
            document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsed } }));
          } else {
            document.querySelectorAll('.cart-count-bubble span,[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          }
          var drawer = document.querySelector('cart-drawer');
          if (opts.open) {
            if (drawer && typeof drawer.show === 'function') drawer.show(opts.focus || null);
            else window.location.href = root + 'cart';
          }
          return parsed;
        });
      });
  }

  /* ---------- main: gallery, form, sticky ---------- */
  function initMain(el) {
    var stage = el.querySelector('[data-cm-stage]');
    var slides = stage ? stage.querySelectorAll('[data-cm-slide]') : [];
    var goBtns = el.querySelectorAll('[data-cm-go]');
    var current = 0;
    function go(i) {
      if (!stage || !slides.length) return;
      i = (i + slides.length) % slides.length;
      stage.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      current = i;
      goBtns.forEach(function (b) { b.classList.toggle('is-active', Number(b.dataset.cmGo) === i); });
    }
    if (stage) {
      var t;
      stage.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { mark(Math.round(stage.scrollLeft / stage.clientWidth)); }, 60);
      }, { passive: true });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      });
    }
    goBtns.forEach(function (b) { b.addEventListener('click', function () { go(Number(b.dataset.cmGo)); }); });
    var prev = el.querySelector('[data-cm-prev]'), next = el.querySelector('[data-cm-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    var form = el.querySelector('[data-cm-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fid = form.getAttribute('id');
        var btns = document.querySelectorAll('button[form="' + fid + '"], [id="' + fid + '"] button[type="submit"]');
        btns.forEach(function (b) { b.disabled = true; b.dataset.label = b.textContent; b.textContent = 'Adding…'; });
        var fd = new FormData(form);
        addToCart(fd.get('id'), fd.get('quantity'), { open: true, focus: e.submitter || null })
          .catch(function () { HTMLFormElement.prototype.submit.call(form); })
          .finally(function () { btns.forEach(function (b) { b.disabled = false; b.textContent = b.dataset.label; }); });
      });
    }

    var sticky = el.querySelector('[data-cm-sticky]');
    var buy = el.querySelector('[data-cm-buy] .cm-cta');
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-show', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        var b = sticky.querySelector('button'); if (b) b.tabIndex = past ? 0 : -1;
      }, { threshold: 0 }).observe(buy);
    }
  }

  /* ---------- add-on buttons (any section) ---------- */
  function initAddons(scope) {
    scope.querySelectorAll('[data-cm-addon]').forEach(function (btn) {
      if (btn.dataset.cmBound) return;
      btn.dataset.cmBound = '1';
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = 'Adding…';
        addToCart(btn.dataset.cmAddon, 1).then(function () {
          btn.classList.add('is-done'); btn.textContent = 'Added ✓';
          setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; btn.disabled = false; }, 2400);
        }).catch(function () { btn.textContent = label; btn.disabled = false; });
      });
    });
  }

  /* ---------- feature tour ---------- */
  function initSpots(el) {
    el.querySelectorAll('[data-cm-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        el.querySelectorAll('[data-cm-tab]').forEach(function (t) {
          var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        el.querySelectorAll('[data-cm-panel]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.cmPanel === tab.dataset.cmTab); });
      });
    });
    el.querySelectorAll('[data-cm-panel]').forEach(function (panel) {
      function activate(i, fromPin) {
        panel.querySelectorAll('[data-cm-pin]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.cmPin === String(i)); });
        panel.querySelectorAll('[data-cm-spot]').forEach(function (s) {
          var on = s.dataset.cmSpot === String(i); s.classList.toggle('is-active', on);
          if (on && fromPin && window.innerWidth < 990) s.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      }
      panel.querySelectorAll('[data-cm-pin]').forEach(function (p) {
        p.addEventListener('click', function () { activate(p.dataset.cmPin, true); });
      });
      panel.querySelectorAll('[data-cm-spot]').forEach(function (s) {
        s.addEventListener('mouseenter', function () { activate(s.dataset.cmSpot, false); });
        s.addEventListener('click', function () { activate(s.dataset.cmSpot, false); });
      });
    });
  }

  /* ---------- garden route: respect reduced motion ---------- */
  function initRoute(el) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var svg = el.querySelector('svg');
      if (svg && svg.pauseAnimations) { svg.pauseAnimations(); svg.setCurrentTime(0); }
    }
  }

  var INITS = { main: initMain, spots: initSpots, route: initRoute };
  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-cm]').forEach(function (el) {
      if (el.dataset.cmInit) return;
      el.dataset.cmInit = '1';
      var f = INITS[el.dataset.cm]; if (f) f(el);
    });
    initAddons(scope);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
